type ValidateDay = (day: string) => boolean;
type ValidateMonth = (month: string) => boolean;
type ValidateYear = (year: string) => boolean;
type GetDays = () => string[];
type GetMonths = () => { label: string; value: string }[];
type GetYears = () => string[];
type MapDob = (dob: string) => false | string;
type MapMonth = (month: string) => string;
type CheckDobFormat = (tag: string) => DobFormat;

export enum DobFormat {
  PARTIAL,
  FULL,
  UNDISCLOSED,
  NONE,
}

export type DOB = {
  day?: string;
  month: string;
  year: string;
  editable?: boolean;
};

export const validateDay: ValidateDay = day => {
  const regex = new RegExp(/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/);
  return regex.test(day);
};

export const validateMonth: ValidateMonth = month => {
  const regex = new RegExp(/^(0[1-9]|1[0-2])$/);
  return regex.test(month);
};

export const validateYear: ValidateYear = year => {
  const regex = new RegExp(/^(19[0-9]{2}|20[0-9]{2})$/);
  const currYear = new Date().getFullYear();
  if (parseInt(year) > currYear) {
    return false;
  }

  return regex.test(year);
};

export const getDays: GetDays = () => [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];
export const getMonths: GetMonths = () => [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const mapMonth: MapMonth = month => {
  const months = getMonths();
  return months.find(m => m.value === month)?.label || "";
};
//because the oldest person is 115 years old rn.
export const getYears: GetYears = () =>
  Array.from(Array(115).keys()).map((key: number) => {
    const thisYear = new Date().getFullYear();
    return (thisYear - key).toString();
  });

export const mapDob: MapDob = dob => {
  if (!dob) return false;
  if (dob.split("/").length !== 3) return false;

  const [day, month, year] = dob.split("/");

  const date = new Date(`${year}-${month}-${day}`);
  return date.toISOString()?.split("T")?.[0] || false;
};

export const checkDobFormat: CheckDobFormat = tag => {
  if (!tag) return DobFormat.NONE;
  if (tag.includes("undisclosed")) return DobFormat.UNDISCLOSED;

  const date = tag.split("dob:")[1];

  const parts = date?.split("/");
  if (!parts || parts.length < 2) return DobFormat.NONE;

  const [p1, p2, p3] = parts;
  if (!p3) return DobFormat.PARTIAL;
  else return DobFormat.FULL;
};
